import styled from 'styled-components';
import { DEVICES } from '../../../config/appConfig';
import Cards from '../../Cards/Cards';

export const StyledCard = styled(Cards)`
  height: ${({ itemStyle }) => itemStyle?.height || '380px'};
  box-shadow: none;
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);
  flex-wrap: wrap;

  @media ${DEVICES.desktop} {
    ${({ itemStyle }) =>
      itemStyle?.isFacilitySection
        ? `
      width: calc(100% / 4 - 14px);
    `
        : `
      width: calc(100% / 5 - 14px);
    `}
  }

  @media (min-width: 1000px) and (max-width: 1230px) {
    ${({ itemStyle }) =>
      itemStyle?.isFacilitySection
        ? `
      width: calc(100% / 4 - 14px);
    `
        : `
      width: calc(100% / 3 - 14px);
    `}
  }

  @media ${DEVICES.tablet} {
    ${({ itemStyle }) =>
      itemStyle?.isFacilitySection
        ? `
      width: calc(100% / 2 - 14px);
    `
        : `
      width: calc(100% / 3 - 14px);
    `}
  }
`;

export const SectionStyled = styled.div`
  ${({ headerStyle }) =>
    headerStyle?.isBackgroundColor && { background: '#efefef' }};
  padding: 20px 0px;
`;

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  .info {
    height: 35px;
    width: 140px;
    border-radius: 35px;
    border: 2px solid #ff9b70;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: white;
  }
  .info_text_style {
    font-size: 16px;
    font-weight: 600;
    color: rgba(255, 81, 6, 1);
    margin: 0px;
  }
  @media ${DEVICES.tablet} {
    gap: 24px;
  }

  @media ${DEVICES.mobile} {
    gap: 22px;
  }

  @media ${DEVICES.sMobile} {
    gap: 18px;
  }
`;

export const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;

  &.content {
    flex-direction: row;
    gap: 10px;
    margin: 15px 0px;
  }

  &.title_mid {
    color: black;
    font-size: 20px;
    font-weight: 500;
  }

  .title_s {
    font-size: ${({ itemStyle }) => itemStyle?.titleSize || '22px'};
    font-weight: ${({ itemStyle }) => itemStyle?.fontWeight || '600'};
  }

  .title_ss {
    font-size: ${({ itemStyle }) => itemStyle?.detailsSize || '14px'};
    font-weight: 400;
  }
  &.card_wrapper {
    flex-direction: row;
    gap: 14px;
    justify-content: center;
    flex-wrap: wrap;
    align-items: ${({ globalStyle }) => globalStyle?.alignItems};
  }

  &.card_container {
    gap: 10px;
    img {
      height: ${({ itemStyle }) => itemStyle?.icon || '43px'};
      width: ${({ itemStyle }) => itemStyle?.icon || '43px'};
      margin-bottom: 8px;
    }
  }
  @media ${DEVICES.tablet} {
    .title_s {
      font-size: 22px;
    }

    .title_ss {
      font-size: 14px;
    }
  }

  @media ${DEVICES.mobile} {
    .title_s {
      font-size: 20px;
    }

    .title_ss {
      font-size: 14px;
    }
  }
  @media ${DEVICES.sMobile} {
    &.title_mid {
      font-size: 16px;
    }
    .title_s {
      font-size: 20px;
    }

    .title_ss {
      font-size: 14px;
    }
  }
`;

export const StyledSpan = styled.span`
  .headerStyle {
    text-align: ${(props) => props.contentStyle?.position || 'left'};
    font-size: 36px;
    font-weight: 600;
    color: ${(props) => props.contentStyle?.heading1Color || '#000000'};
  }
  .title_or {
    text-align: ${(props) => props.contentStyle?.position || 'left'};
    font-size: 36px;
    font-weight: 600;
    color: ${(props) => props.contentStyle?.heading2Color || '#f58220'};
  }

  @media ${DEVICES.tablet} {
    .headerStyle {
      font-size: 34px;
    }
    .title_or {
      font-size: 34px;
    }
  }

  @media ${DEVICES.mobile} {
    .headerStyle {
      font-size: 32px;
    }
    .title_or {
      font-size: 32px;
    }
  }

  @media ${DEVICES.sMobile} {
    .headerStyle {
      font-size: 22px;
    }
    .title_or {
      font-size: 22px;
    }
  }
`;
